import { mdiShieldCheck } from '@mdi/js';
import { useNavigate, useParams } from 'react-router';

import { IUserPortfolioItemProps } from 'user/types';
import {
    goToRelatedPortfolioItemViewPage,
    goToPortfolioItemViewPage,
} from 'user/utils/goToRoutes';
import {
    IExtendedCertificateFragment,
    IPortfolioItemListItemOldFragment,
} from 'graphql/types';
import { PortfolioListItem } from 'user/components/PortfolioListItem';

export const CertificatePortfolioItem = ({
    className,
    withEditActions,
    ...item
}: IUserPortfolioItemProps<IPortfolioItemListItemOldFragment>) => {
    const navigate = useNavigate();

    const { id: userId } = useParams();

    const certificate = item?.relatedObject as IExtendedCertificateFragment;

    const { thumbnail, training } = certificate || {};

    return (
        <PortfolioListItem
            className={className}
            icon={mdiShieldCheck}
            image={thumbnail?.url || undefined}
            item={item}
            title={training?.title}
            onClick={(id) => {
                if (!id) return;

                if (!userId) {
                    goToRelatedPortfolioItemViewPage(navigate, id);

                    return;
                }

                goToPortfolioItemViewPage(navigate, userId, id);
            }}
        />
    );
};
